import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ConflictTask.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Tabs, Tab, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Button, Dialog, InputBase } from '@material-ui/core';
import { roleStr, defaultPageSize, isRole, ROLES, ADD, VIEW, EDIT, ONGOING, COMPLETED, DISABLED } from '../../common/common';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import TaskInfo from './components/TaskInfo';
import AlertDialog from '../Layout/components/AlertDialog';
import Search from '@material-ui/icons/Search'

class ConflictTask extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tasksData: [{
                name: 'zhangsan',
                description: 'dd',
                principal_id: 'dd',
                principal_name: 'dd',
                result: 'dd',
                client:{
                    first_name:'li',
                    last_name:'si',
                },
                status: ONGOING
            }],
            reference_number: '',
            dialogTitle: '',
            dialogData: {},
            dialogState: ADD,
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
            open: false,
            showAlert: false,
        }
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            tasksData,
            page_index,
            page_size,
            total_items,
            dialogTitle,
            dialogData,
            dialogState,
            open,
            showAlert,
        } = this.state;
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="Conflict of interest check" subtitle="MANAGEMENT"></PageTitle>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search reference number"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'reference_number')}
                        />
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Task Name</TableCell>
                                <TableCell>Task desc</TableCell>
                                <TableCell>Principal</TableCell>
                                <TableCell>Client Name</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tasksData.map(row => (
                                <TableRow key={row.principal_id} role="checkbox">
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.description}</TableCell>
                                    <TableCell>{row.principal_name}</TableCell>
                                    <TableCell>{row.client.first_name + " " + row.client.last_name}</TableCell>
                                    <TableCell>{statusView(row.status)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {tasksData.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={tasksData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={open}>
                    <TaskInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                    ></TaskInfo>
                </Dialog>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this task?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.doGetTasks();
    }
    doGetTasks() {
        const { page_index, page_size, reference_number } = this.state;
        let params = {
            reference_number,
            page_index,
            page_size
        }
        this.getTasks(params);
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("TASK INFO", VIEW);
    }
    handleEdit(e, obj) {
        // this.setState(() => ({
        //     dialogData: obj
        // }))
        // console.log(obj)
        // this.openDialog("EDIT TASK", EDIT);
        this.openInfo(obj)
    }
    openInfo(data) {
        this.props.history.push("/main/conflictTaskInfo?id=" + data.id);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }))
    }
    handleCreate(result, status) {
        const { dialogData } = this.state;
        console.log(result, status)
        this.putTask(dialogData.id, result, status);
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleAlertYes() {
        const { dialogData } = this.state;
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            dialogData: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    handleSearch(e, name) {
        const value = e.target.value;
        this.setState({
            [name]: value,
            page_index: 1
        }, () => {
            this.doGetTasks();
        })
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getTasks();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getTasks();
        });
    }
    //---------------request---------------
    getTasks(params) {
        instance.get(BASE_URL + 'conflict/task', { params }).then((res) => {
            const tasksData = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(tasksData)
            this.setState(() => ({
                tasksData,
                page_size,
                total_items
            }));
        })
    }
    putTask(task_id, result, status) {
        let params = {
            result,
            status,
        }
        instance.put(BASE_URL + roleStr() + `/conflict/task/${task_id}`, params).then((res) => {
            console.log(res.data.data);
            this.doGetTasks();
        })
    }
}

export default withRouter(ConflictTask);